import service from './modules/service';

const modules = {
  service,
};

export default {
  ...modules,
};



// WEBPACK FOOTER //
// ./src/mixins/index.js